// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.stats-grid-container {
  width: 100%;
}

/* Icon wrapper */
.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Loader */
.stats-grid-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 160px;
}

/* Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  background: #e0eefe;
}

@media (min-width: 1024px) {
  .stats-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

/* Card */
.stats-card {
  position: relative;
  padding: 22px 12px;
  background: #f8f8f8;
}

/* ---------------- MOBILE (2 columns) ---------------- */

/* Vertical divider */
.stats-card:nth-child(odd) {
  border-right: 2px solid #00060e3f;
}

/* Horizontal divider for first row */
.stats-card:nth-child(-n + 2) {
  border-bottom: 2px solid #00060e3f;
}

/* ---------------- DESKTOP (4 columns) ---------------- */
@media (min-width: 1024px) {
  /* Vertical dividers */
  .stats-card:not(:nth-child(4n)) {
    border-right: 2px solid #00060e3f;
  }

  /* Middle horizontal divider */
  .stats-card:nth-child(-n + 4) {
    border-bottom: 2px solid #00060e3f;
  }
}

/* Header */
.stats-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.icon-box {
  width: 44px;
  height: 44px;
  background: #dceafe; /* soft blue background */
  border-radius: 12px; /* rounded corners */
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  width: 22px;
  height: 22px;
  color: #1d4ed8; /* strong blue icon */
}

.stats-title {
  font-size: 15px;
  font-weight: 600;
  margin: 0;
}

/* Value */
.stats-value {
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 8px 0;
}

/* Footer */
.stats-footer {
  display: flex;
  align-items: center;
}

.stats-badge {
  font-size: 10px;
  font-weight: 600;
  background: #f1f5f9;
  padding: 4px 10px;
  border-radius: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Cards/StatsGrid.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,yDAAyD;;AAEzD,qBAAqB;AACrB;EACE,iCAAiC;AACnC;;AAEA,qCAAqC;AACrC;EACE,kCAAkC;AACpC;;AAEA,0DAA0D;AAC1D;EACE,sBAAsB;EACtB;IACE,iCAAiC;EACnC;;EAEA,8BAA8B;EAC9B;IACE,kCAAkC;EACpC;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAE,yBAAyB;EAC9C,mBAAmB,EAAE,oBAAoB;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAE,qBAAqB;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,UAAU;AACV;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":["/* Container */\n.stats-grid-container {\n  width: 100%;\n}\n\n/* Icon wrapper */\n.icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Loader */\n.stats-grid-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 160px;\n}\n\n/* Grid */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  background: #e0eefe;\n}\n\n@media (min-width: 1024px) {\n  .stats-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n/* Card */\n.stats-card {\n  position: relative;\n  padding: 22px 12px;\n  background: #f8f8f8;\n}\n\n/* ---------------- MOBILE (2 columns) ---------------- */\n\n/* Vertical divider */\n.stats-card:nth-child(odd) {\n  border-right: 2px solid #00060e3f;\n}\n\n/* Horizontal divider for first row */\n.stats-card:nth-child(-n + 2) {\n  border-bottom: 2px solid #00060e3f;\n}\n\n/* ---------------- DESKTOP (4 columns) ---------------- */\n@media (min-width: 1024px) {\n  /* Vertical dividers */\n  .stats-card:not(:nth-child(4n)) {\n    border-right: 2px solid #00060e3f;\n  }\n\n  /* Middle horizontal divider */\n  .stats-card:nth-child(-n + 4) {\n    border-bottom: 2px solid #00060e3f;\n  }\n}\n\n/* Header */\n.stats-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.icon-box {\n  width: 44px;\n  height: 44px;\n  background: #dceafe; /* soft blue background */\n  border-radius: 12px; /* rounded corners */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon {\n  width: 22px;\n  height: 22px;\n  color: #1d4ed8; /* strong blue icon */\n}\n\n.stats-title {\n  font-size: 15px;\n  font-weight: 600;\n  margin: 0;\n}\n\n/* Value */\n.stats-value {\n  font-size: 22px;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n}\n\n/* Footer */\n.stats-footer {\n  display: flex;\n  align-items: center;\n}\n\n.stats-badge {\n  font-size: 10px;\n  font-weight: 600;\n  background: #f1f5f9;\n  padding: 4px 10px;\n  border-radius: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
